// extracted by mini-css-extract-plugin
module.exports = {"number":"number-2syV5","close":"close-3k9H4","title":"title-1cO71","passenger":"passenger-3Rah8","item":"item-3iFU4","name":"name-3Whs6","info":"info-1x9lT"};